import Head from 'next/head';
import type { Tab } from '../../types/tab';

/** LinkTagProps */
interface LinkTagProps {
  imageList: string[];
  initialTab: Tab;
}

/**
 * 画像リソースキャッシュ用コンポーネント
 */
export const LinkTag = ({ imageList, initialTab }: LinkTagProps) => {
  return (
    <Head>
      {imageList.map((src) => {
        return initialTab === 'pr' ? (
          <link rel="preload" href={src} as="image" key={src} />
        ) : (
          <link rel="prefetch" href={src} key={src} />
        );
      })}
    </Head>
  );
};
